import { useState } from "react";
import { toast } from "sonner";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Switch } from "../../components/ui/switch";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { api } from "../client";
import { Field } from "../ui";

const CATS = ["Coffee", "Brewery & Taphouse", "Sports Bar", "Restaurant", "Nightlife"];
const BLANK = { name: "", category: "Coffee", address: "", city: "Monmouth", state: "OR", zip: "", is_partner: false };

export default function AnchorVenueModal({ open, onClose, onSaved }) {
  const [f, setF] = useState(BLANK);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const close = () => { setF(BLANK); onClose(); };
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const r = await api("/staff/venues/anchor", { method: "POST", body: { ...f, zip: f.zip || null } });
      toast.success(r.geocode_source === "nominatim" ? "Venue added with map location" : "Venue added (used city center location)");
      close(); onSaved();
    } catch (e2) { toast.error(e2.message); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && close()}>
      <DialogContent className="staff-root max-h-[90vh] overflow-y-auto border-[var(--s-line)] bg-[var(--s-panel)]" data-testid="anchor-venue-modal">
        <DialogHeader><DialogTitle className="s-display">Add new anchor venue</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <Field label="Name"><Input required value={f.name} onChange={set("name")} className="s-input" data-testid="anchor-name" /></Field>
          <Field label="Category">
            <Select value={f.category} onValueChange={(v) => setF({ ...f, category: v })}>
              <SelectTrigger className="s-input" data-testid="anchor-category"><SelectValue /></SelectTrigger>
              <SelectContent>{CATS.map((c) => <SelectItem key={c} value={c} data-testid={`anchor-category-${c.toLowerCase().replace(/[^a-z]+/g, "-")}`}>{c}</SelectItem>)}</SelectContent>
            </Select>
          </Field>
          <Field label="Address"><Input required value={f.address} onChange={set("address")} className="s-input" data-testid="anchor-address" /></Field>
          <div className="grid grid-cols-3 gap-3">
            <Field label="City"><Input required value={f.city} onChange={set("city")} className="s-input" data-testid="anchor-city" /></Field>
            <Field label="State"><Input required value={f.state} onChange={set("state")} className="s-input" data-testid="anchor-state" /></Field>
            <Field label="Zip"><Input value={f.zip} onChange={set("zip")} className="s-input" data-testid="anchor-zip" /></Field>
          </div>
          <label className="flex items-center gap-3 text-sm"><Switch checked={f.is_partner} onCheckedChange={(v) => setF({ ...f, is_partner: v })} data-testid="anchor-is-partner" />Sparkd Partner</label>
          <p className="text-xs text-[var(--s-dim)]">The map location is found automatically from the address.</p>
          <Button type="submit" disabled={busy} className="s-btn w-full" data-testid="anchor-submit">{busy ? "Locating & saving…" : "Add anchor venue"}</Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
